<template>
    <div class="row">
        <div
            class="col-sm-3 text-center"
            v-show="records && records.length > 0"
            v-for="record in records"
            :key="record.id"
        >
            <div class="d-flex justify-content-center">
                <img :src="certificateImageUrl" width="90px"/>
            </div>
            <br>
            <div class="d-flex justify-content-center">
                <b class="text-capitalize">
                    {{ record.request_type }}
                </b>
            </div>
            <div class="d-flex justify-content-center">
                <small class="text-danger">
                    Expires on
                    {{ record.expiry_date | getDateFormat }}
                </small>
            </div>

            <div class="d-flex justify-content-center">
                <base-button
                    size="sm"
                    type="success"
                    @click="printHospitalLetter(record)"
                    v-if="record && record.letter"
                >
                    <i class="fa fa-print"></i>
                    {{ isLoading && isIndex ? 'Please Wait...' : 'Open Document'}}
                </base-button>
            </div>
            <br>
        </div>

    </div>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'LetterData',
        props: ['records'],
        filters: {
            getDateFormat(value) {
                return moment(value).format('Do MMM, YYYY');
            }
        },
        data() {
            return {
                isLoading: false,
                isIndex: null
            }
        },
        computed: {
            ...mapGetters(['certificateImageUrl', 'hospital', 'getPrintHospitalLetterUrl'])
        },
        methods: {
            ...mapActions(['downloadAnyFile']),
            printHospitalLetter(record) {
                this.isLoading = true;
                this.isIndex = record.id;
                const data = { 
                    id: record.id, 
                    option: 'user',
                    hospital_id: this.hospital.id,
                    date: record.approved_date,
                    ref_no: record.letter.ref_no,
                    last_quota: record.letter.last_quota,
                    plenary: record.letter.plenary,
                    plenary_date: record.letter.plenary_date,
                    plenary_venue: record.letter.plenary_venue,
                    visit_date: record.letter.visit_date,
                    quota: record.letter.quota,  
                    url : this.getPrintHospitalLetterUrl,
                    contentType : 'application/pdf',
                    fileName :  'hospital-letter.pdf',
                    msg : 'Failed to export Hospital Letter:'
                };
                return this.downloadAnyFile(data).then((res) => {// download file
                    this.isLoading = res; // stop loading
                    this.isIndex = null;
                });
            }
        }
    }
</script>

<style scoped>
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>
